<template>
  <div class="pt-5 features" id="features">
    <div class="container mt-5">
      <div class="row flex-column-reverse flex-sm-row">
        <div class="col-sm-6 d-flex justify-content-center align-items-center">
          <img
              src="../../assets/img/screenshots/features-1-billing.png"
              class="img-screenshot img-screenshot-portrait screenshot img-shadow"
              data-aos="fade-up"
              data-aos-duration="1000"
              data-aos-once="false"
          />
        </div>
        <div class="col-sm-6 p-5 text-center d-flex flex-column align-items-center justify-content-center">
          <h1 class="title">Verstuur facturen</h1>
          <div class="sub-title">
            SimpleFinance helpt ondernemers facturen snel te versturen. Verstuur je vaak dezelfde facturen?
            Maak dan een product of dienst aan en voeg deze met één klik toe.
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-sm-6 p-5 text-center d-flex flex-column align-items-center justify-content-center">
          <h1 class="title">Houd kosten bij</h1>
          <div class="sub-title">
            Gebruik om de kosten die je voor de onderneming maakt bij te houden. Zo kan je op elk moment zien hoe je
            bedrijf er voor staat. En als je een belastingaangifte invult helpt je snel aan de juiste gegevens.
          </div>
        </div>
        <div class="col-sm-6 d-flex justify-content-center align-items-center">
          <img
              src="../../assets/img/screenshots/features-2-costs.png"
              class="img-screenshot img-screenshot-portrait screenshot img-shadow"
              data-aos="fade-down"
              data-aos-duration="1000"
              data-aos-once="false"
          />
        </div>
      </div>
    </div>
    <div class="container mt-5">
      <div class="row flex-column-reverse flex-sm-row">
        <div class="col-sm-6 d-flex justify-content-center align-items-center">
          <img
              src="../../assets/img/screenshots/features-3-relations.png"
              class="img-screenshot img-screenshot-portrait screenshot img-shadow"
              data-aos="fade-up"
              data-aos-duration="1000"
              data-aos-once="false"
          />
        </div>
        <div class="col-sm-6 p-5 text-center d-flex flex-column align-items-center justify-content-center">
          <h1 class="title">Beheer klanten</h1>
          <div class="sub-title">
            Beheer de contacten van je onderneming in SimpleFinance. Wanneer een klant in je adresboek staat gaat het sturen van een
            factuur extra snel.
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-sm-6 p-5 text-center d-flex flex-column align-items-center justify-content-center">
          <h1 class="title">Houd overzicht</h1>
          <div class="sub-title">
            SimpleFinance biedt je het overzicht over hoe het financieel met je bedrijf gaat. Hoe doe je het deze maand
            ten opzicht van een jaar geleden? Hoe doe je het dit jaar ten opzicht van vorig jaar? En wat moet ik bij
            mijn belastingaangifte invullen?
          </div>
        </div>
        <div class="col-sm-6 d-flex justify-content-center align-items-center">
          <img
              src="../../assets/img/screenshots/features-4-dashboard.png"
              class="img-screenshot img-screenshot-portrait screenshot img-shadow"
              data-aos="fade-down"
              data-aos-duration="1000"
              data-aos-once="false"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Features'
};
</script>

<style scoped>
.features {
  padding-bottom: 150px;
  min-height: 950px;
  background: #fff;
  background-size: 120% 120%;
}
</style>
